<template>
  <LinkA class="link-button" :bgcolor="Color" :href="Link" target="_blank">
    <span>🔗</span>
  </LinkA>
</template>

<script>
import styled from 'vue-styled-components'
import Color from 'color'
import { colors } from '@/styles/theme'
import * as _ from '@/styles/mixins'

// STYLES
const props = {
  bgcolor: String
}

const LinkA = styled('a', props)`
  ${_.buttonCircle};
  ${_.flexCenteredAll};
  border: 2px solid ${colors.fc[1]};
  background-color: ${colors.white};
  filter: drop-shadow(0 0 10px ${props => Color(props.bgcolor).rotate(-20)});
  bottom: 1rem;
  right: 1rem;
  transform: translateX(8rem);
  span {
    padding-top: 2px;
    font-size: 3rem;
    transform-origin: center center;
    animation: Rotation 5s linear infinite;
  }
  ${_.media.desktop`
    width: 8rem;
    height: 8rem;
    bottom: 3rem;
    right: 2rem;
    transform: translateX(15vmin);
    span {
      font-size: 3.5rem;
      padding-top: 3px;
      padding-right: 3px;
    }
  `}
  ${_.media.hover`
    &:hover {
      span {
        animation-duration: .25s;
      }
    }
  `}
`

// VUE
export default {
  props: [
    'Color',
    'Link'
  ],
  components: {
    LinkA
  }
}
</script>
